// extracted by mini-css-extract-plugin
module.exports = {"empty":"index_empty__1MSqU","empty-tip":"index_empty-tip__2U8pP","emptyTip":"index_empty-tip__2U8pP"};